/* eslint-disable import/prefer-default-export */
import { combineReducers } from 'redux'

import auth from '../scenes/Auth/services/authReducer'
import admin from '../scenes/Session/services/reducers/adminReducer'
import orgs from '../scenes/Session/services/reducers/organizationsReducer'
import services from '../scenes/Session/services/reducers/servicesReducer'

import groups from '../scenes/Session/services/reducers/groupsReducer'
import preferredLanguages from '../scenes/Session/services/reducers/preferredLanguagesReducer'
import onboarding from '../scenes/Session/services/reducers/onboardingReducer'
import users from '../scenes/Session/services/reducers/usersReducer'
import integrations from '../scenes/Session/services/reducers/integrationsReducer'
import campaigns from '../scenes/Session/services/reducers/campaignsReducer'
import darkly from '../scenes/Session/services/reducers/darklyReducer'
import templates from '../scenes/Session/services/reducers/templatesReducer'
import typeahead from '../scenes/Session/services/reducers/typeaheadReducer'
import messages from '../scenes/Session/services/reducers/messagesReducer'
import adminDash from '../scenes/Session/scenes/AdminDashboardContainer/services/reducers/adminDashReducer'
import intelligence from '../scenes/Session/services/reducers/intelligenceReducer'

const epReducer = combineReducers({
  auth,
  admin,
  orgs,
  groups,
  preferredLanguages,
  onboarding,
  users,
  integrations,
  campaigns,
  templates,
  typeahead,
  messages,
  adminDash,
  services,
  darkly,
  intelligence
})

export const rootReducer = (state, action) => epReducer(state, action)
